import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import AddQRCodeLayer from "./AddQRCodeLayer";


const AddQRCodePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        
        {/* AddQRCodeLayer */}
        <AddQRCodeLayer />


      </MasterLayout>
    </>
  );
};

export default AddQRCodePage;
